import { useTranslation } from "react-i18next";

export default function HowToResetPassword() {
  const { t } = useTranslation("common");

  return (
    <main className="how-to-container">
      <div className="steps-container">
        <div className="steps-column">
          <div className="step">
            <h4 className="step-title">{t("Step 1")}</h4>
            <p className="step-description">{t("ResetPassword-Step1")}</p>
          </div>
          <div className="step">
            <h4 className="step-title">{t("Step 2")}</h4>
            <p className="step-description">{t("ResetPassword-Step2")}</p>
          </div>
        </div>
        <div className="steps-column">
          <div className="step">
            <h4 className="step-title">{t("Step 3")}</h4>
            <p className="step-description">{t("ResetPassword-Step3")}</p>
          </div>
          <div className="step">
            <h4 className="step-title">{t("Step 4")}</h4>
            <p className="step-description">{t("ResetPassword-Step4")}</p>
          </div>
        </div>
      </div>
      <div className="how-to-video">
        <h4 className="video-title">{t("InstructionalVideo")}</h4>
        <iframe
          width="100%"
          height="480px"
          src="https://www.youtube.com/embed/uLI540BH-Hw?si=PEkJ6A3Oact_94Vs"
          title="How to Reset Password YouTube Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    </main>
  );
}
